var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloset = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.085 15.16H7.213v-1.733h2.872zM16.787 15.16h-2.872v-1.733h2.872z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.223 1A2.786 2.786 0 0 1 21 3.794v15.412A2.786 2.786 0 0 1 18.223 22H5.777A2.786 2.786 0 0 1 3 19.206V3.794A2.786 2.786 0 0 1 5.777 1zM5.777 2.735c-.582 0-1.053.474-1.053 1.059v15.412c0 .585.471 1.06 1.053 1.06h5.266V2.734zm6.989 17.53h5.457c.582 0 1.053-.474 1.053-1.059V3.794c0-.585-.471-1.06-1.053-1.06h-5.457z",
  clipRule: "evenodd"
})));
export default SvgCloset;